import Api from "../apiService";

class attachmentsApi {
  async readFile(url, { signal } = {}) {
    // Файл уже доступен по URL: JWT API не передаём в стороннее хранилище
    const response = await fetch(url, { signal, credentials: "omit" });
    if (!response.ok) throw new Error("Не удалось загрузить файл");
    return response.arrayBuffer();
  }

  index(companyId, params = {}) {
    return Api.getRequest(
      `companies/${companyId}/attachments`,
      params,
      Api.authHeaders()
    );
  }

  show(companyId, attachmentId) {
    return Api.getRequest(
      `companies/${companyId}/attachments/${attachmentId}`
    );
  }

  create(companyId, attachmentsData, isMultipart = false, config = {}) {
    let headers = Api.authHeaders();

    if (isMultipart) {
      delete headers["Content-Type"];
    }

    return Api.postRequest(
      `companies/${companyId}/attachments`,
      attachmentsData,
      headers,
      config
    );
  }

  delete(companyId, attachmentId) {
    return Api.deleteRequest(
      `companies/${companyId}/attachments/${attachmentId}`
    );
  }
}

export default new attachmentsApi();
